import React, { useEffect, useState, lazy, Suspense } from "react";
import HomeMap from "../components/Home/HomeMap";
import "../components/Home/home.scss";
import EducationDashboard from "../components/Home/EducationDashboard";
import { useDispatch, useSelector } from "react-redux";
import Reports from "../components/Report/Reports";
import { useTranslation } from "react-i18next";
import FilterDropdown3016 from "../components/Home/filter/FilterDropdown3016";
import { handleShowDistrict, handleShowFilter } from "../redux/slice/headerSlice";
import { fetchDashboardData, fetchMaptatsData, fetchMaptatsOtherData, fetchMapSchoolsStatsData,fetchMapTeacherStatsData,fetchMapTeacherTrainedStatsData, fetchMapStudentsStatsData, fetchMapStudentsGPIStatsData, fetchSchoolStatsData, fetchSchoolStatsIntData, fetchTeachersStatsData, fetchTeachersStatsIntData, fetchStudentStatsData, fetchStudentStatsIntData } from "../redux/thunks/dashboardThunk";
import { modifiedFilterObjForReset, modifiedFilterObjResetDashboard } from "../constants/constants";
import { changeYearFilter,changeStateFilter,changeDistrictFilter, allFilter } from "../redux/slice/schoolFilterSlice";
import FooterDashboard from "../components/Header/FooterDashboard";
import SchoolDashboard from "../components/Home/SchoolDashboard";
import TeacherDashboard from "../components/Home/TeacherDashboard";
import StudentDashboard from "../components/Home/StudentDashboard";
import Heilight from "../components/Home/Heilight";
import { fetchArchiveServicesGraphSchoolData } from "../redux/thunks/archiveServicesThunk";


export default function Home() {
  const dispatch = useDispatch();
  const header_name = useSelector((state) => state.header);
  const schoolFilter = useSelector((state) => state?.schoolFilter);
  const filterObj = structuredClone(schoolFilter);
  const mapsFilter = useSelector((state) => state.mapFilters);
  let mapFilterObj = structuredClone(mapsFilter);
  const [customClass, setCustomClass] = useState("");
  const handleClass = (e) => setCustomClass(e);
  const handleRemoveClass = () => setCustomClass("open_map_sec");
  const handleLoadOrRefresh = () => {
    filterObj.yearId=11;
    window.sessionStorage.setItem("yearId",11);
    dispatch(changeYearFilter(11))
    dispatch(changeDistrictFilter(99))
    dispatch(changeStateFilter(10))
    dispatch(fetchMaptatsData(modifiedFilterObjForReset));
    dispatch(fetchMapSchoolsStatsData(modifiedFilterObjForReset));
    dispatch(fetchMapTeacherStatsData(modifiedFilterObjForReset));
    dispatch(fetchMapTeacherTrainedStatsData(modifiedFilterObjForReset));
    dispatch(fetchMapStudentsStatsData(modifiedFilterObjForReset));
    dispatch(fetchMapStudentsGPIStatsData(modifiedFilterObjForReset));
    dispatch(fetchMaptatsOtherData(modifiedFilterObjForReset));
   window.sessionStorage.setItem("isYearMapped","N");
   window.sessionStorage.setItem("isStateMapped","N");
  };

  useEffect(() => {
    handleLoadOrRefresh();
    const handleBeforeUnload = () => {
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  
  useEffect(() => {
    window.localStorage.setItem("map_district_name", "District");
    window.localStorage.setItem("district", "District");
    window.localStorage.setItem("map_state_name", "All India/National");
    window.localStorage.setItem("state_wise", "All India/National");
    window.localStorage.setItem("state", "All India/National");
    window.localStorage.setItem("year", "2024-25");
    window.sessionStorage.setItem("yearId", "11");
    dispatch(handleShowFilter(false));
    dispatch(handleShowDistrict(false));
  }, []);

  setTimeout(function(){
    if(window.sessionStorage.getItem("isStateMapped") =="Y"){
    }
    else if(window.sessionStorage.getItem("isYearMapped") =="Y"){
      dispatch(changeYearFilter(window.sessionStorage.getItem("yearId")))
      filterObj.yearId=window.sessionStorage.getItem("yearId");
      modifiedFilterObjForReset.yearId=window.sessionStorage.getItem("yearId");
      dispatch(fetchMaptatsData(modifiedFilterObjForReset));
        dispatch(fetchMapSchoolsStatsData(modifiedFilterObjForReset));
        dispatch(fetchMapTeacherStatsData(modifiedFilterObjForReset));
        dispatch(fetchMapTeacherTrainedStatsData(modifiedFilterObjForReset));
        dispatch(fetchMapStudentsStatsData(modifiedFilterObjForReset));
        dispatch(fetchMapStudentsGPIStatsData(modifiedFilterObjForReset));
        dispatch(fetchMaptatsOtherData(modifiedFilterObjForReset));
    }
  }, 10);


  const { t } = useTranslation();

  return (
    <>
      <section
  className={`${
      (header_name.headerName !== "All Reports" &&
       header_name.headerName !== "Highlight")
        ? header_name.removeBeforeAfterClass
        : ""
    } ptb-0 bg-white ${customClass}`}
  id="content"
>

      <div className={`container border-r-b ${
    header_name.headerName !== "Highlight" ? "bg-grey" : ""
  }`}>
          <div className="row">
            {header_name.headerName === "All Reports" ? (
              <Reports />
            )  : header_name.headerName === "Highlight" ? (
              
                      <Heilight />
                    ) : (
              <>
                <button
                  className="header-dropdown-btn open-map-btn"
                  title="Open Map"
                  onClick={() => handleRemoveClass("close_map_sec")}
                >
                  {t("open_map_button")}
                </button>
                <div className="col-sm-12 col-md-6 col-lg-6 map_hide_on_click_btn">
                  <div className="map-sec-h">
                    <HomeMap
                      handleClass={handleClass}
                      customClass={customClass}
                    />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 sec_full_width">
                  <div className="right-content-box">
                    {header_name.headerName === "Education Dashboard" ? (
                      <EducationDashboard/>
                    ) : header_name.headerName === "School Dashboard" ? (
                      <SchoolDashboard />
                    ) : header_name.headerName === "Teacher Dashboard" ? (
                      <TeacherDashboard />
                    ) : header_name.headerName === "Student Dashboard" ? (
                      <StudentDashboard />
                    ): (
                      <EducationDashboard />
                    )}
                  </div>
                  <a href="https://dashboard.udiseplus.gov.in/udiseplus-archive" target="_blank" class="header-dropdown-btn archives triangle triangle-2">{t("udise_archives")}</a>

                </div>
              </>
            )}
          </div>
        </div>
      </section>
      <FooterDashboard />
      {(header_name.headerName !== "All Reports" && header_name.headerName !== "Highlight") && <FilterDropdown3016 isAllYearShow={false} />}
    </>
  );
}